  <template>
  <div class="electronicInvoice">
    <el-dialog
      top="5vh"
      v-loading="loading"
      title="电子发票查询"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
    >
      <div style="height: 75vh; overflow-y: auto">
        <el-button @click="makeInvoice" v-if="ERP.isPermission(4004001001)">开电子发票</el-button>
        <el-button @click="selects_s">查询</el-button>
        <el-button @click="titleManageVisible = true;">发票抬头管理</el-button>
        <el-button @click="handleOpenAddress">不动产地址设置</el-button>
        <div>
          <el-descriptions
            :column="2"
            border
            size="mini"
            style="margin-top: 10px"
            :labelStyle="{ width: '123px' }"
            :contentStyle="{ width: '42%' }"
          >
            <el-descriptions-item label="房产信息">
              <el-select
                v-model="select.house"
                size="mini"
                placeholder="可搜索房产"
                filterable
                remote
                clearable
                reserve-keyword
                :remote-method="remoteMethod"
                style="width: 100%"
              >
                <el-option
                  v-for="item in house"
                  :key="item.id"
                  :label="item.house"
                  :value="item.house"
                ></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="查询方式">
              <el-radio v-model="date.type" label="1">模糊查询</el-radio>
              <el-radio v-model="date.type" label="2">精确查询</el-radio>
            </el-descriptions-item>
            <el-descriptions-item label="缴费日期">
              <el-date-picker
                v-model="date.date_s"
                type="date"
                size="mini"
                style="width: 47%"
                placeholder="开始日期"
              ></el-date-picker>
              <span style="margin-left: 1px; margin-right: 1px">至</span>
              <el-date-picker
                v-model="date.date_e"
                type="date"
                size="mini"
                style="width: 47%"
                placeholder="结束日期"
              ></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="发票号码">
              <el-input
                size="mini"
                v-model="invoice_no"
                clearable
                placeholder="发票号码"
              ></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="缴费票据号">
              <el-input size="mini" v-model="xsc_bill_no" clearable placeholder="票据号"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="票据类型">
              <el-radio v-model="date.bill_type" label="0">全部</el-radio>
              <el-radio v-model="date.bill_type" label="1">待开票</el-radio>
              <el-radio v-model="date.bill_type" label="2">已开票</el-radio>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="margin-top: 10px">
          <span>选中金额：
            <span style="color: red">{{ money_val }}</span>元
          </span>
          <span style="margin-left: 15px">
            总金费：<span style="color: red">{{ money }}</span>元
          </span>
          <span style="margin-left: 15px; color: red" v-if="loading_table == 2">加载中...</span>
          <el-table
            ref="multipleTable"
            :data="tableData"
            border v-loading="loading_table > 1"
            tooltip-effect="dark"
            style="width: 100%"
            height="50vh"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.invoice_no"
                  size="mini"
                  @click="viewInvoice(scope.row.invoice_id)"
                >查看发票</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="invoice_no" label="发票号码" width="150"></el-table-column>
            <el-table-column prop="customer" label="姓名" width="100"></el-table-column>
            <el-table-column prop="h_name_date" label="房产" width="260"></el-table-column>
            <el-table-column prop="chargeitem_name" label="收费项目" width="140"></el-table-column>
            <el-table-column
              prop="xsc_Price"
              label="单价"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="xsc_Amount"
              label="数量"
              width="80"
            ></el-table-column>
            <el-table-column label="计费周期" width="180">
              <template slot-scope="scope">
                {{ scope.row.startDate }}-{{ scope.row.endDate }}
              </template>
            </el-table-column>
            <el-table-column
              prop="charge_paid"
              label="收款金额"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="dis_count"
              label="减免金额"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="payment"
              label="支付方式"
              width="109"
            ></el-table-column>
            <el-table-column
              prop="operator_date"
              label="缴款时间"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              width="200"
            ></el-table-column>
          </el-table>
          <el-pagination
            background
            layout="sizes, total, prev, pager, next"
            @size-change="selects_s"
            @current-change="selects_s"
            :total="total"
            :current-page.sync="page"
            :page-size.sync="pageSize"
            :page-sizes="[20, 50, 100, 200, 500]"
            style="float: right"
          />
        </div>
      </div>
    </el-dialog>

    <electronic-invoice-form ref="invoiceFormRef" :order_type="'paid_order'" @close="selects_s"></electronic-invoice-form>

    <invoice-detail  v-if="invoiceId > 0" :invoiceId="invoiceId" :visible="invoiceDetailVisible"
                     @close="invoiceDetailVisible = false"></invoice-detail>
    <title-manage :visible="titleManageVisible" @close="titleManageVisible = false" :pid="pid"></title-manage>

    <el-dialog :visible.sync="addressVisible" title="不动产地址设置">
      <el-form ref="addressSettingRef" :model="addressSetting" label-width="80px">
        <el-form-item label="所在省市">
          <el-input v-model="addressSetting.realEstatePlace"></el-input>
        </el-form-item>
        <el-form-item label="完整地址">
          <el-input v-model="addressSetting.fullAddress"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" @click="saveAddress">提交</el-button>
          <el-button @click="addressVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import InvoiceDetail from "@/components/Admin/Finance/invoiceDetail.vue";
  import TitleManage from "@/components/Admin/Finance/invoiceTitleManage.vue";
  import ElectronicInvoiceForm from "@/components/Admin/Order/order/electronicInvoiceForm.vue";

export default {
  name: "ElectronicInvoice",
  components: {
    InvoiceDetail ,
    TitleManage ,
    ElectronicInvoiceForm
  },
  // 接受父组件的值
  props: {},
  data() {
    return {
      loading_table: 1,
      dialogVisible: false,
      dialogButton: false,
      tableData: [],
      order: [],
      money_val: 0,
      money: 0,
      total: 0,
      page: 1,
      pageSize: 20,
      pid: "",
      date: {
        date_s: "",
        date_e: "",
        bill_type: "0",
        type: "1",
        select: "明细",
      },
      select: {
        pay: "",
        house: "",
        name: "",
        date: "",
      },
      invoice_no: "",
      house: [],
      remerks: "",
      loading: false,
      customerName: "",
      xsc_bill_no : "",
      invoiceForm: {
        orderDetailIds: [],
        title: "",
        phone: "",
        taxNo: "",
        address: "",
        remark: "",
        bank: "",
        bankAccount: "",
        email: "" ,
        invoice_type : '82',
        taxAddressType : 0,
        realEstatePlace : '',
        fullAddress : '',
      },
      rules: {
        title: [{ required: true, message: "请填写发票抬头", trigger: "blur" }],
        phone: [
          { required: true, message: "请填写电话/邮箱", trigger: "blur" },
        ],
      },
      isDigitization: false,

      searchInvoiceTitle : '',
      titleLoading: false,
      titleOptions: [],
      selectTitleId : 0,
      timeout : null,

      invoiceId: 0,
      invoiceDetailVisible: false,

      titleManageVisible : false,

      addressVisible : false,
      addressSetting : {
        realEstatePlace : '',
        fullAddress : '',
      },
    };
  },
  watch: {
    dialogButton(n, o) {
      if (n === true) {
        this.checkIsDigitization();
      }
    },
  },
  mounted() {},
  //事件
  methods: {
    //返回数据
    getInvo(data, house, pid) {
      this.pid = pid;
      this.select = data;
      if (this.date.date_s == "") {
        this.date.date_s = data.date;
        this.date.date_e = data.date;
      }
      this.house = house;
      this.dialogVisible = true;
      this.selects_s();
    },
    selects_s() {
      this.money = "加载中";
      this.total = 1;
      this.selects();
      let data = {
        select: this.select,
        date: this.date,
        xsc_bill_no: this.xsc_bill_no,
        remerks: this.remerks,
        pid: this.pid,
        invoice_no : this.invoice_no,
      };
      //分页
      this.$myhttp
        .post("admin/OrderList/getElectronicInvoiceSelect_page", data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then(
          (backdata) => {
            // 异步执行成功后
            this.total = backdata.data.count;
          },
          (err) => {
            this.$Message.error("请求异常!");
          }
        );
      //金额
      this.$myhttp
        .post("admin/OrderList/getElectronicInvoiceSelect_money", data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then(
          (backdata) => {
            // 异步执行成功后
            this.money = backdata.data.money;
          },
          (err) => {
            this.$Message.error("请求异常!");
          }
        );
    },
    selects() {
      this.loading_table = 2;
      let data = {
        select: this.select,
        date: this.date,
        xsc_bill_no: this.xsc_bill_no,
        remerks: this.remerks,
        page: this.page,
        pageSize: this.pageSize,
        pid: this.pid,
        invoice_no : this.invoice_no
      };
      this.$myhttp
        .post("admin/OrderList/getElectronicInvoiceSelect", data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then(
          (backdata) => {
            // 异步执行成功后
            this.tableData = backdata.data.data;
            this.loading_table = 1;
          },
          (err) => {
            this.loading_table = 1;
            this.$Message.error("请求异常!");
          }
        );
    },
    handleClose(done) {
      done();
    },
    handleSelectionChange(val) {
      // console.log(val, "----------");
      this.order = val;
      let money = 0;
      this.order.map((req) => {
        money = Number(money) + Number(req.charge_paid);
      });
      this.money_val = money.toFixed(2);
    },
    makeInvoice() {
      let id = this.order.map((req) => {
        return req.id;
      });
      if (id.length == 0) {
        this.$Message.error("请选择开票订单");
        return null;
      }
      let orderList = this.order.map(item => ({
        ...item,
        invoice_money: item.charge_paid,
        charge : item.charge_paid
      }));
      this.$refs.invoiceFormRef.openInvoiceForm(this.pid , orderList )
    },
    //远程搜索
    remoteMethod(query) {
      if (query !== "") {
        this.$myhttp
          .get("admin/common/house_name1?house_name=" + query, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            // 异步执行成功后
            this.house = backdata.data.data;
          });
      }
    },
    viewInvoice(id) {
      this.invoiceId = id;
      this.invoiceDetailVisible = true;
    },
    checkIsDigitization() {
      let that = this;
      this.invoiceForm.realEstatePlace = '';
      this.invoiceForm.fullAddress = '';
      this.$myhttp
        .post(
          "admin/InvoiceDisc/checkIsDigitization",
          { pid: this.pid , order_type : 'paid_order' , order_ids : this.invoiceForm.orderDetailIds },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.isDigitization = backdata.data.data.is_digitization;
            if(backdata.data.data.is_estate_lease){
              that.invoiceForm.taxAddressType = 1;
              that.invoiceForm.realEstatePlace = backdata.data.data.real_estate_place;
              that.invoiceForm.fullAddress = backdata.data.data.full_address;
            }else{
              that.invoiceForm.taxAddressType = 0;
            }
          }
          console.log('invoiceForm' , that.invoiceForm)
        })
        .catch((err) => {});
    },
    selectable(row){
      return row.invoice_id == 0 || row.invoice_id == null;
    },
    handleOpenAddress(){
      this.$myhttp.post("admin/getInvoiceAddress", {id : this.pid} ,{
          "Content-Type": "application/x-www-form-urlencoded",
        }).then((backdata) => {
          if(backdata.data.code == 200){
          this.addressVisible = true;
          this.addressSetting.realEstatePlace = backdata.data.data.realEstatePlace;
          this.addressSetting.fullAddress = backdata.data.data.fullAddress;
        }else{
          this.$message.error(backdata.data.msg);
          }
      });
    },
    saveAddress(){
      let data = {
        id : this.pid,
        realEstatePlace : this.addressSetting.realEstatePlace,
        fullAddress : this.addressSetting.fullAddress,
          }
      this.$myhttp.post("admin/setInvoiceAddress", data ,{
        "Content-Type": "application/x-www-form-urlencoded",
      }).then((backdata) => {
        if(backdata.data.code == 200){
          this.$message.success(backdata.data.msg);
          this.addressVisible = false;
        }else{
          this.$message.error(backdata.data.msg);
        }
      });
    },
  },
};
</script>

  <style scoped>
  .electronicInvoice /deep/ .el-autocomplete {
    width: 100%;
  }
  </style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/electronicInvoice.vue